import React from 'react';
import StaticKeyMetricCard from './StaticKeyMetricCard';
import useDorisMetricByWeekId from 'src/serverProxy/useDorisMetricByWeekId';
import { INDEX_FIELDS, METRICTYPE } from 'src/utils/entityDefinitions';
import { useRetailerId } from 'src/utils/Hooks/reduxSelectors';
import { getAppName } from 'src/utils/app';
import { WeekRange } from 'src/utils/Hooks/typedHooks';
import { useWeekRange } from 'src/utils/Hooks';

interface DorisMetricCardsProps {
  variant: 'large' | 'small' | 'medium';
  queryKey: string;
  apiMetricType: string;
  MetricToDisplay: METRICTYPE;
  indexName: string;
  fieldName: string;
  title: string;
  onClick?: () => void;
}
/**
 * @deprecated Use New Doris Metric Cards instead - will be removed after we deprecate for Warner Bros data load
 */
const DorisMetricCards = ({
  queryKey,
  apiMetricType,
  MetricToDisplay = METRICTYPE.VOLUME,
  fieldName,
  indexName,
  variant,
  title,
  onClick
}: DorisMetricCardsProps) => {
  const weekRange = useWeekRange();

  const metricByValues = useDorisMetricByWeekId({
    queryKey: queryKey || '',
    metricType: apiMetricType,
    metricTypeDisplay: MetricToDisplay,
    resultCount: 1200
  });

  const {
    primaryData,
    secondaryData,
    isLoading,
    formattedPrimaryTotal,
    formattedPercentChange,
    formattedPercentChangeLastValues,
    percentChangeLastValues,
    percentChange,
    formattedLastPrimaryValue
  } = metricByValues;

  const useLatestWeek =
    INDEX_FIELDS.getField(getAppName(), indexName, fieldName).timePeriodAggregationFunctionType === 'lastValue' ||
    weekRange === WeekRange.LAST_WEEK;

  const mainMetric = useLatestWeek ? formattedLastPrimaryValue : formattedPrimaryTotal;

  const rawChange = useLatestWeek ? percentChangeLastValues : percentChange;
  const change = useLatestWeek ? formattedPercentChangeLastValues : formattedPercentChange;

  return (
    <StaticKeyMetricCard
      variant={variant}
      indexName={indexName}
      fieldName={fieldName}
      title={title}
      onClick={onClick}
      isLoading={isLoading}
      primaryData={primaryData}
      secondaryData={secondaryData}
      formattedPrimaryTotal={mainMetric}
      percentChange={rawChange}
      formattedPercentChange={change}
    />
  );
};
/**
 * @deprecated Use New Doris Metric Cards instead - will be removed after we deprecate for Warner Bros data load
 */
export default DorisMetricCards;
